import { useEffect, useState } from "react";
import { motion, useMotionValue } from "framer-motion";

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const [hovering, setHovering] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target.closest?.("a, button, [role='button'], input, textarea, [data-cursor='hover']");
      setHovering(!!el);
    };
    const leave = () => setHidden(true);
    const enter = () => setHidden(false);
    window.addEventListener("mousemove", move, { passive: true });
    document.addEventListener("mouseleave", leave);
    document.addEventListener("mouseenter", enter);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseleave", leave);
      document.removeEventListener("mouseenter", enter);
    };
  }, [x, y]);

  return (
    <div className="hidden md:block" aria-hidden="true">
      <motion.div
        className="fixed top-0 left-0 rounded-full border border-[#75FB4E] z-[140] pointer-events-none"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: hovering ? 44 : 30,
          height: hovering ? 44 : 30,
          borderColor: hovering ? "rgba(117,251,78,0.9)" : "rgba(117,251,78,0.5)",
          backgroundColor: hovering ? "rgba(117,251,78,0.08)" : "rgba(117,251,78,0)",
          opacity: hidden ? 0 : 1,
        }}
        transition={{ duration: 0.18, ease: "easeOut" }}
      />
    </div>
  );
}
